import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

export default function PropertyCharts() {
  // Property Types Data
  const propertyTypes = [
    { name: 'Residential', value: 100 }
  ];

  // Rental Strategy Data
  const rentalStrategy = [
    { name: 'Short-term Rental', value: 100 }
  ];

  // Using secondary (orange) color from our theme
  const COLORS = ['#f97316'];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
      {/* Property Types Chart */}
      <div className="h-[300px]">
        <h4 className="font-inter font-bold text-[20px] leading-[32px] text-gray-900 mb-4 text-center">Property Types</h4>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={propertyTypes}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={80}
              fill="#8884d8"
              paddingAngle={5}
              dataKey="value"
            >
              {propertyTypes.map((_, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Rental Strategy Chart */}
      <div className="h-[300px]">
        <h4 className="font-inter font-bold text-[20px] leading-[32px] text-gray-900 mb-4 text-center">Rental Strategy</h4>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={rentalStrategy}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={80}
              fill="#8884d8"
              paddingAngle={5}
              dataKey="value"
            >
              {rentalStrategy.map((_, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}